import { useMemo } from "react";
import { usePayoutCoverage } from "./useMe";

/**
 * Filters availableChannels (from useCorridor, keyed by channel type e.g.
 * "mobile_money" / "bank_transfer" / "sepa") down to the channels Blupay
 * actually supports for the given country, per GET /me/corridors
 * (usePayoutCoverage).
 *
 * Returns [key, channel] entries, same shape as
 * Object.entries(corridor.availableChannels), so it drops in wherever
 * that was previously used directly.
 */
export function useSupportedChannels(
  countryCode,
  availableChannels
) {
  const { coverage } = usePayoutCoverage();

  return useMemo(() => {
    const allowedKeys =
      coverage[
        String(countryCode || "").toUpperCase()
      ] ?? [];

    return Object.entries(
      availableChannels ?? {}
    ).filter(([key]) =>
      allowedKeys.includes(key)
    );
  }, [coverage, countryCode, availableChannels]);
}
